// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"237":"job-offers-details","719":"unsubscribe","976":"job-offers"}[chunkId] + "." + {"237":"53d2ab23","719":"04e632ef","976":"8a60486e"}[chunkId] + ".js";
};